<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="禮物名稱" prop="name" >
        <a-input v-model="form.name" placeholder="请输入禮物名稱" />
      </a-form-model-item>
      <a-form-model-item label="團舞禮物名稱" prop="teamName" >
        <a-input v-model="form.teamName" placeholder="请输入團舞禮物名稱" />
      </a-form-model-item>
      <a-form-model-item label="禮物图片" prop="image" >
          <a-upload
            listType="picture-card"
            class="avatar-uploader"
            :showUploadList="false"
            :customRequest='fileUploadRequest'
            :beforeUpload="beforeUpload"
            @change="handleChange"
          >
            <img v-if="form.image" :src="form.image" alt="图片" style="height:104px;max-width:300px"/>
            <div v-else>
              <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
          <p style="color:#ff0000">图片建议宽高比：100*100 </p>
          <span style="color:#ff0000">图片限制小于5M </span>
      </a-form-model-item>

        <svga-upload
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="禮物特效"
          :value="form.imageEffects"
          :required="true"
          @change="svgaCallBack"
        />
      <span style="color:#ff0000">特效限制小于5M </span>

      <a-form-model-item label="禮物米幣数" prop="integralNum" >
        <a-input v-model="form.integralNum" placeholder="请输入禮物米幣数" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort" >
        <a-input-number v-model="form.sort" placeholder="请输入排序" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getGift, addGift, updateGift } from '@/api/platform/gift'
import UploadFileToOSS from "@/utils/upload-file-to-oss";
import SvgaUpload from '@/components/SvgaUpload'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    SvgaUpload
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },

      // 表单参数
      form: {
        id: null,

        name: null,

        teamName: null,

        integralNum: null,

        sort: null,

        image: null,

        imageEffects: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '禮物名稱不能为空', trigger: 'blur' }
        ],
        image: [
          { required: false, message: '禮物图片不能为空', trigger: 'blur' }
        ],
        integralNum: [
          { required: true, message: '禮物米幣数不能为空', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    svgaCallBack(value){
      console.log("value=======132213142422545====>",value)
      this.form.imageEffects = value;
    },
    fileUploadRequest(fileInfo) {
      this.uploadLoading = true
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          console.log("res========>"+JSON.stringify(res))
          // Log.info('multi-img-upload', res);
          const ossUrl = res[0].url;
          fileInfo.file.ossUrl = ossUrl;
          fileInfo.file.ossName = ossUrl;
          fileInfo.onSuccess();
        },
      });
    },
    beforeUpload: function (file) {
      return new Promise((resolve, reject) => {
        if(file.size>5*1024*1000){
          this.$message.warning("图片大小不能超过5M----")
          return reject(false)
        }

        var fileType = file.type;
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片');
          return reject(false);
        }
        resolve(true)
      });
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true
        return
      }
      if (info.file.status === 'done') {
        // let response = info.file.response;
        this.uploadLoading = false;
        this.form.image = info.file.originFileObj.ossUrl;
      }
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,

        name: null,

        image: null,

        imageEffects: null,

        integralNum: null,

        sort: null
      }
     /* this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })*/
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getGift({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateGift(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addGift(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
